import {IClientFilterModel} from "../../Model/FilterModel/ClientFilterModel.js";
import {IClientModel} from "../../Model/Client/ClientModel.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";


export class ClientRead {
            public static Read = async (filter: IClientFilterModel) => {
                const url = "/client/"
                return JsonFetchJson.Post<ResponseApi<Array<IClientModel>>>(url, filter)
                    .then(response => {
                        return response.Data
                    });
            }
        }
